"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MVFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_161)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_161`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 -0.00012207H30V23.9999H-6V-0.00012207Z",
					fill: "#D01920"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.17395 6.26074H19.8262V17.7393H4.17395V6.26074Z",
					fill: "#017C3B"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.9325 15.391C12.0596 15.391 10.5412 13.8727 10.5412 11.9997C10.5412 10.1267 12.0595 8.60838 13.9325 8.60838C14.5165 8.60838 15.0659 8.75604 15.5457 9.01599C14.7931 8.28002 13.7639 7.82581 12.6281 7.82581C10.323 7.82581 8.45422 9.6945 8.45422 11.9997C8.45422 14.3049 10.323 16.1736 12.6281 16.1736C13.7639 16.1736 14.7931 15.7193 15.5457 14.9834C15.066 15.2434 14.5166 15.391 13.9325 15.391Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_161`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MVFlag };
